import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as Counter from './Counter';
import * as WeatherForecasts from './WeatherForecasts';
import * as Jabatans from './Jabatans';
import * as Occupations from './Occupations';
import * as Position from './Position.Reducer'
import * as BusinessField from './BusinessField.Reducer';
import * as Province from './Province.Reducer';
import * as City from './City.Reducer';
import * as Bank from './Bank.Reducer';
import * as BcaValidation from './BcaValidation.Reducer';
import * as Register from './Register.Reducer';
import * as PengkinianData from './PengkinianData.Reducer';
import * as AccountOfficer from './AccountOfficer.Reducer';

export default function configureStore(history, initialState) {
    const reducers = {
        counter: Counter.reducer,
        weatherForecasts: WeatherForecasts.reducer,
        jabatans: Jabatans.reducer,
        occupations: Occupations.reducer,
        positions: Position.reducer,
        businessFields: BusinessField.reducer,
        province: Province.reducer,
        city: City.reducer,
        bank: Bank.reducer,
        bcaValidation: BcaValidation.reducer,
        register: Register.reducer,
        pengkinianData: PengkinianData.reducer,
        accountOfficers: AccountOfficer.reducer,
    };

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js